import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { SuchePageRoutingModule } from "./suche-routing.module";

import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { UtilComponentsModule } from "../../util/components/util-components.module";
import { FacetComponent } from "./facet/facet.component";
import { SuchePage } from "./suche.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SuchePageRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserModule,
    UtilComponentsModule,
  ],
  declarations: [SuchePage, FacetComponent],
})
export class SuchePageModule {}
